var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceVisaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4645_5431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 7.58099C11.6666 10.4977 9.62492 11.956 7.19825 12.8018C7.07118 12.8449 6.93315 12.8428 6.80742 12.796C4.37492 11.956 2.33325 10.4977 2.33325 7.58099V3.49766C2.33325 3.34295 2.39471 3.19458 2.50411 3.08518C2.6135 2.97578 2.76188 2.91432 2.91659 2.91432C4.08325 2.91432 5.54159 2.21432 6.55659 1.32766C6.68017 1.22207 6.83737 1.16406 6.99992 1.16406C7.16246 1.16406 7.31967 1.22207 7.44325 1.32766C8.46409 2.22016 9.91659 2.91432 11.0833 2.91432C11.238 2.91432 11.3863 2.97578 11.4957 3.08518C11.6051 3.19458 11.6666 3.34295 11.6666 3.49766V7.58099Z",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 7.0026L6.41667 8.16927L8.75 5.83594",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#555555"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4645_5431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceVisaIcon);
export default __webpack_public_path__ + "static/media/dice-visa-icon.4ac5bfb52ef4c5995a0352a411651dd5.svg";
export { ForwardRef as ReactComponent };